import MyReservationsTable from './MyReservationsTable';

export default MyReservationsTable;
